export const digitsOnly = value => String(value || '').replace(/\D/g, '');

export const maskDocumentoInput = value => {
  const digits = digitsOnly(value).slice(0, 14);
  if (digits.length <= 11) {
    const parts = [
      digits.slice(0, 3),
      digits.slice(3, 6),
      digits.slice(6, 9),
      digits.slice(9, 11),
    ];
    let out = parts[0];
    if (parts[1]) out += `.${parts[1]}`;
    if (parts[2]) out += `.${parts[2]}`;
    if (parts[3]) out += `-${parts[3]}`;
    return out;
  }

  const parts = [
    digits.slice(0, 2),
    digits.slice(2, 5),
    digits.slice(5, 8),
    digits.slice(8, 12),
    digits.slice(12, 14),
  ];
  let out = parts[0];
  if (parts[1]) out += `.${parts[1]}`;
  if (parts[2]) out += `.${parts[2]}`;
  if (parts[3]) out += `/${parts[3]}`;
  if (parts[4]) out += `-${parts[4]}`;
  return out;
};

export const formatDocumento = value => {
  const digits = digitsOnly(value);
  if (digits.length === 11) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  if (digits.length === 14) {
    return digits.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      '$1.$2.$3/$4-$5'
    );
  }
  return value || '—';
};

export const isValidDocumentoLength = value => {
  const length = digitsOnly(value).length;
  return length === 11 || length === 14;
};
